import React from 'react';
import { 
  Bars3Icon,
  SunIcon,
  MoonIcon,
} from '@heroicons/react/24/outline';
import NotificationBell from '../limits/NotificationBell';

interface HeaderProps {
  isSidebarOpen: boolean;
  onToggleSidebar: () => void;
  isDarkMode: boolean;
  onToggleTheme: () => void;
}

const Header: React.FC<HeaderProps> = ({
  isSidebarOpen,
  onToggleSidebar,
  isDarkMode,
  onToggleTheme,
}) => {
  return (
    <header className={`fixed top-8 right-0 h-16 bg-light-surface dark:bg-dark-surface border-b border-light-border dark:border-dark-border flex items-center px-6 z-20 transition-all duration-200 ${
      isSidebarOpen ? 'md:left-64 left-0' : 'left-0'
    }`}>
      {/* Left side */}
      <div className="flex items-center gap-4">
        <button
          onClick={onToggleSidebar}
          className="p-2 rounded-md hover:bg-light-hover dark:hover:bg-dark-hover transition-colors duration-200"
        >
          <Bars3Icon className="w-5 h-5 text-gray-600 dark:text-gray-400" />
        </button>

        {!isSidebarOpen && (
          <div className="flex items-center gap-3">
            <img 
              src="/images/ana_logo.png" 
              alt="ANA Logo" 
              className="h-8 w-auto"
            />
            <span className="text-xl font-bold text-gray-900 dark:text-white">
              Admin Panel
            </span>
          </div>
        )}
      </div>

      {/* Right side */}
      <div className="flex-1 flex justify-end items-center gap-3">
        <NotificationBell />
        
        <button
          onClick={onToggleTheme}
          className="hidden md:flex items-center justify-center p-2 rounded-md bg-light-card dark:bg-dark-card hover:bg-light-hover dark:hover:bg-dark-hover transition-colors duration-200"
          aria-label="Toggle theme"
        >
          {isDarkMode ? (
            <SunIcon className="w-5 h-5 text-primary-500" />
          ) : (
            <MoonIcon className="w-5 h-5 text-primary-500" />
          )}
        </button>
      </div>
    </header>
  );
};

export default Header;
